import styled from '@emotion/styled'

import { MOBILE } from '../../../guided-toolbox/utils/breakpoints'

// Inset the content blocks so the scrollbar stays against the panel edge.
const MOBILE_INSET = '0 20px'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 100%;

  ${MOBILE} {
    padding: ${MOBILE_INSET};
  }
`

const HeaderBlock = styled.div`
  ${MOBILE} {
    padding: ${MOBILE_INSET};
  }
`

const HeaderLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;

  /* Offset the label slightly so it aligns visually with the heading. */
  padding-left: 2.5px;

  color: ${p => p.theme.mediumGray};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;

  ${MOBILE} {
    padding-left: 1px;
  }
`

const CloseButton = styled.button`
  display: none;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  ${MOBILE} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Heading = styled.span`
  display: block;
  font-size: 38px;
  line-height: 52px;

  ${MOBILE} {
    color: ${p => p.theme.lightestGray};
    font-size: 23px;
    font-weight: 400;
    line-height: 24px;
  }
`

const HeadingEmphasis = styled.strong`
  font-weight: 600;

  ${MOBILE} {
    font-weight: 700;
  }
`

const CardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 135px));
  justify-content: center;
  gap: 20px 33px;
  margin-top: 10px;

  ${MOBILE} {
    grid-template-columns: repeat(2, minmax(0, 135px));
    margin-top: 22px;
  }
`

const ValuesBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 2px solid ${p => p.theme.primaryLighter ?? '#d4ebf2'};
  border-radius: 10px;
`

const ValuesHeading = styled.div`
  color: ${p => p.theme.mediumGray};
  font-size: 20px;
  font-weight: 300;
  line-height: 24px;
`

const CustomControls = styled.div`
  display: flex;
  align-items: baseline;
  gap: 40px;

  ${MOBILE} {
    flex-wrap: wrap;
    gap: 8px 4px;
  }
`

const CustomBlock = styled.div`
  margin-top: 2px;
  margin-bottom: 12px;
`

const PercentField = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  color: ${p => p.theme.lightestGray};
  font-size: 14px;
  line-height: 18px;

  & input {
    text-align: center;
  }

  /* Remove BaseInput's unused label and error spacing. */
  & > div {
    margin-top: 0;
    min-height: 0;
    padding: 0;
  }

  ${MOBILE} {
    /* Flatten the wrapper so the label can sit below the input and slider. */
    display: contents;
  }
`

const PercentLabel = styled.span`
  ${MOBILE} {
    order: 1;
    flex: 0 0 100%;
  }
`

const PercentSuffix = styled.span`
  font-size: 18px;
`

const SliderBox = styled.div`
  flex: 1 1 400px;
  align-self: center;

  ${MOBILE} {
    flex: 1 1 auto;
    width: auto;
  }
`

const Footer = styled.div`
  display: flex;

  /* Keep Cancel left of Save on desktop; stack Save above Cancel on mobile. */
  flex-wrap: wrap-reverse;

  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: auto;
  padding-top: 32px;

  ${MOBILE} {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    align-items: stretch;
  }
`

export {
  Content,
  HeaderBlock,
  HeaderLabelRow,
  CloseButton,
  Heading,
  HeadingEmphasis,
  CardRow,
  ValuesBox,
  ValuesHeading,
  CustomControls,
  CustomBlock,
  PercentField,
  PercentLabel,
  PercentSuffix,
  SliderBox,
  Footer,
}
